import { render, staticRenderFns } from "./OptionsList.vue?vue&type=template&id=12e59b4e&"
import script from "./OptionsList.vue?vue&type=script&lang=ts&"
export * from "./OptionsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports